"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { FileText } from "lucide-react";
function ResourceListConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="space-y-4">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex gap-4 animate-pulse">
            <div className="size-24 shrink-0 rounded-lg bg-muted/50" />
            <div className="flex-1 space-y-2">
              <div className="h-5 w-3/4 rounded bg-muted/50" />
              <div className="h-4 w-full rounded bg-muted/50" />
              <div className="h-4 w-5/6 rounded bg-muted/50" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="rounded-lg border border-border bg-muted/30 p-6 text-center">
        <p className="text-sm text-muted-foreground">
          Unable to load resources. Please try again later.
        </p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="rounded-lg border border-border bg-muted/30 p-6 text-center">
        <FileText className="mx-auto mb-3 size-10 text-muted-foreground/40" />
        <p className="text-sm text-muted-foreground">
          No resources available at this time.
        </p>
      </div>;
  }
  return <div className="space-y-4">
      {posts.slice(0, 3).map((post, i) => <article key={post.id} data-index={i} className="group flex gap-4 rounded-lg p-4 transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] hover:bg-muted/60">
          <div className="relative size-24 shrink-0 overflow-hidden rounded-lg bg-muted/40">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="size-full object-cover" /> : <div className="flex size-full items-center justify-center">
                <FileText className="size-8 text-muted-foreground/30" />
              </div>}
          </div>
          <div className="flex min-w-0 flex-1 flex-col justify-center gap-1.5">
            <h3 className="line-clamp-1 text-base font-semibold leading-tight text-foreground">
              {post.title}
            </h3>
            {post.excerpt && <p className="line-clamp-2 text-sm leading-relaxed text-muted-foreground">
                {post.excerpt}
              </p>}
            {post.link && <Link to={post.link} className="mt-1 inline-flex items-center text-sm font-medium text-primary transition-transform duration-[150ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1">
                Read more →
              </Link>}
          </div>
        </article>)}
    </div>;
}
export default function ResourceLibraryHighlights() {
  return <section className="bg-background py-16">
      <div className="container mx-auto max-w-3xl px-6">
        <div className="mb-8">
          <h2 className="text-3xl font-semibold text-foreground">
            Resource Library Highlights
          </h2>
          <p className="mt-2 text-base text-muted-foreground">
            Explore our latest articles, guides, and insights to help your business grow.
          </p>
        </div>
        <PostsProvider className="resource-highlights-wrapper" wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "_embedded", "_links.wp:featuredmedia"]}>
          <ResourceListConsumer />
        </PostsProvider>
      </div>
    </section>;
}